import {
  Component,
  h,
  Prop,
  State,
  Event,
  EventEmitter,
  Listen,
  Element,
} from "@stencil/core";
import { createRipple } from "../../utils/utils";

@Component({
  tag: "signet-option",
})
export class SignetOption {
  @Element() $el: HTMLElement;

  @Prop() value: string;
  @Prop() label: string;

  @State() selectedValue: string;

  // @Prop() disabled: boolean = false;

  @Event() optionSelected: EventEmitter<string>;
  @Event() optionLabel: EventEmitter<string>;

  @Listen("selectedValue", { target: "body" })
  selectedValueHandler(event: CustomEvent<string>) {
    this.selectedValue = event.detail;
  }

  @Event() closeSelect: EventEmitter;

  onClick(value: string, event) {
    createRipple(event.currentTarget, event);
    this.optionSelected.emit(value);
    this.optionLabel.emit(this.label) || this.value;
    this.closeSelect.emit();

    // Vue 2: emit 'input' event
    this.$el.dispatchEvent(new CustomEvent('input', {
      bubbles: true,
      composed: true,
      detail: value
    }));

    // Vue 3: emit 'update:modelValue' event
    this.$el.dispatchEvent(new CustomEvent('update:modelValue', {
      bubbles: true,
      composed: true,
      detail: value
    }));
  }

  // componentWillRender() {
  //   if (this.selectedValue === this.value) {
  //     this.optionLabel.emit(this.label);
  //   }
  // }

  render() {
    return (
      <div
        role="listitem"
        onClick={(ev) => this.onClick(this.value, ev)}
        class={
          this.value === this.selectedValue
            ? "select-option-selected"
            : "select-option"
        }
      >
        {this.label || this.value}
      </div>
    );
  }
}
